<template>
    <section v-if="subscriber.pvrs">
        <div class="filter search_only">
            <div class="field_left">
                <p class="field">
                    <label for="vyhledavani" v-translate>Vyhledávání</label>
                    <input class="search clearable" id="vyhledavani" name="vyhledavani" size="30" v-model="searchText" type="text">
                    <a @click="clearFilter" id="vyhledavani_delete" class="clearable_btn" :title="$gettext('Vymazat text')" :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
                </p>
            </div>
            <div class="field_right" v-if="this.subscriberSummed.pvr_free_minutes">
                <div class="remaining-space">
                    <div class="progressbar">
                        <div class="progressbar__actual" :style="{ 'width': this.usedMinutesPercentage + '%' }">
                            <div class="progressbar__show" :style="{ 'width': (100 - this.usedFilteredMinutesPercentage) + '%' }" />
                        </div>
                    </div>
                    <div class="actual-space">{{ usedTimeFormattedString }}</div>
                </div>
            </div>
        </div>

        <div class="table_overflow">
          <table class="vypis">
            <thead>
                <tr v-if="this.filteredPvrs.length > 0">
                    <th class="no_padding drag_drop"></th>
                    <th class="no_padding checkbox"></th>
                    <th><span class="name"><strong v-translate>Název</strong></span></th>
                    <th><span v-translate>Stav</span></th>
                    <th><span v-translate>Kanál</span></th>
                    <th><span v-translate>Nahráno na</span></th>
                    <th><span v-translate>Uživatelské profily</span></th>
                    <th><span v-translate>Délka</span></th>
                    <th><span v-translate>Datum vysílání</span></th>
                    <th><span v-translate>Datum nahrání</span></th>
                    <th><span v-translate>Datum expirace</span></th>
                    <th class="no_padding edit"></th>
                </tr>
            </thead>
            <tbody>
                <PvrRow v-for="pvr in this.filteredPvrs"
                        :pvr="pvr"
                        :key="pvr.id"
                        ref="pvr_row"
                        :selectedEntities="selectedEntities"
                        :isDeletable="isEditable"
                        @input="select"
                        @deletePvr="onDeletePvr" />
                <tr v-if="this.filteredPvrs.length === 0">
                    <td colspan="9" v-translate>Nebyly nalezeny žádné nahrávky.</td>
                </tr>
            </tbody>
        </table>
        </div>
      <local-list-action-line
          :entities="filteredPvrs"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="executeMultipleAction"
      ></local-list-action-line>
    </section>
</template>

<script>
	import PvrRow from "./PvrRow";
  import localTable from "@/components/mixins/local-table"

  export default {
		name: "Pvrs",
    components: {PvrRow},
    mixins: [localTable],
    props: {
      subscriber: Object,
      subscriberSummed: Object,
      isEditable: Boolean,
		},
    data () {
        return {
            searchText: ""
        }
    },
    methods: {
        clearFilter() {
            this.searchText = "";
        },
        onDeletePvr(id) {
            this.$emit('deletePvr', id)
        },
      executeMultipleAction(action, activeKey) {
        let actionIds = this.selectedEntities.join();
        switch (action) {
          case 'delete-multi':
            this.onDeletePvr(actionIds);
            break;
          default:
            this.runMultipleAction(action, activeKey);
        }
      },
    },
    computed: {
        entities(){
          return Object.values(this.filteredPvrs);
        },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
          {value: 'delete-multi', text: this.$gettext('Smazat')}
        ];
      },
        csvHeaders(){
          return {
            'name': {name: this.$gettext('Název')},
            'state': {name: this.$gettext('Stav'), callback: (entity, index) => { return this.$refs.pvr_row[index].stateString()}},
            'name_channel': {name: this.$gettext('Kanál'), callback: (entity) => {return entity.channel_hd ? entity.name_channel + ' HD' : entity.name_channel;}},
            'name_device': {name: this.$gettext('Nahráno na')},
            'profiles': {name: this.$gettext('Uživatelské profily'), callback: (entity) => {return entity.profiles.map(i => i.name).join(', ')}},
            'length': {name: this.$gettext('Délka'), callback: (entity) => {return this.$_formatMinutesToString(entity.length / 60)}},
            'timestamp_broadcast_start': {name: this.$gettext('Datum vysílání'), callback: (entity) => {return entity.timestamp_broadcast_start ? this.$_datetime_format(entity.timestamp_broadcast_start) : ''}},
            'timestamp_created': {name: this.$gettext('Datum vysílání'), callback: (entity) => {return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''}},
            'timestamp_expiration': {name: this.$gettext('Datum vysílání'), callback: (entity) => {return entity.timestamp_expiration ? this.$_datetime_format(entity.timestamp_expiration) : ''}},
          }
        },
        filteredPvrs() {
            if (!this.searchText) {
                return this.subscriber.pvrs;
            }

            let searchText = this.searchText.toLowerCase();

            return this.subscriber.pvrs.filter((pvr) => {
                return pvr.name.toLowerCase().includes(searchText)
                    || pvr.name_channel.toLowerCase().includes(searchText)
                    || pvr.id.toString().includes(searchText);
            });
        },
        usedMinutes() {
            let seconds = 0;

            for (const pvr of this.subscriber.pvrs) {
                seconds += pvr.length;
            }

            return seconds / 60;
        },
        usedFilteredMinutes() {
            let seconds = 0;

            for (const pvr of this.filteredPvrs) {
                seconds += pvr.length;
            }

            return seconds / 60;
        },
        usedMinutesPercentage() {
            return ~~((this.usedMinutes / this.freeMinutes) * 100);
        },
        usedFilteredMinutesPercentage() {
            return ~~((this.usedFilteredMinutes / this.usedMinutes) * 100);
        },
        freeMinutes() {
            return this.subscriberSummed.pvr_free_minutes || 0;
        },
        formattedFreeHours() {
            return this.$_formatMinutesToString(this.freeMinutes);
        },
        formattedUsedHours() {
            return this.$_formatMinutesToString(this.usedMinutes);
        },
        usedTimeFormattedString() {
            if (this.usedMinutes > 0) {
                return this.$gettextInterpolate(this.$gettext("Využito %{used} z %{total}"), {
                    used: this.formattedUsedHours,
                    total: this.formattedFreeHours
                });
            } else {
                return this.$gettextInterpolate(this.$gettext("K dispozici %{total}"), {
                    total: this.formattedFreeHours
                });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/pvrs/Pvrs.vue